import { render } from "./CheckboxSimpleComponent.vue?vue&type=template&id=4caa5668&scoped=true"
import script from "./CheckboxSimpleComponent.vue?vue&type=script&lang=js"
export * from "./CheckboxSimpleComponent.vue?vue&type=script&lang=js"

import "./CheckboxSimpleComponent.vue?vue&type=style&index=0&id=4caa5668&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4caa5668"]])

export default __exports__